
import { Field, Label, Select } from "@zendeskgarden/react-forms";
import BaseModal from "../../../ui/Modal";
import IconInfo from '@zendeskgarden/svg-icons/src/16/info-stroke.svg?react';
import * as Css from "./style"

export function TicketTemplateModal({
    onClose,
    forms,
    selectedForm,
    setSelectedForm,
    onDownload,
}: any) {
    return (
        <BaseModal
            title="Template personalizado"
            onClose={onClose}
            onClick={onDownload}
            buttonTitle="Baixar Template"
            buttonCloseTitle="Cancelar"
        >
            <div>
                <p style={{ marginBottom: 16 }}>
                    Se quiser um template mais completo, selecione um formulário de ticket
                    e incluiremos automaticamente os campos adicionais.
                </p>

                <Field>
                    <Label>Selecionar formulário (opcional)</Label>
                    <Select
                        value={selectedForm ?? ""}
                        onChange={(e) => setSelectedForm(Number(e.target.value))}
                    >
                        <option value="">Usar formulário padrão</option>
                        {forms.map((f: any) => (
                            <option key={f.id} value={f.id}>
                                {f.name}
                            </option>
                        ))}
                    </Select>
                </Field>

                <Css.ContainerInfo >
                    <div className="title">
                        <IconInfo />
                        <p>Dica</p>
                    </div>
                    <span>Ao preencher as tags, separe-as por vírgula.</span>
                </Css.ContainerInfo>
            </div>

        </BaseModal>
    );
}
